import { sanitizeCustomFields } from '../utils/sanitizeCustomFields';

type PersonioBaseConfig = {
  subsidiary: string;
  subcompany: string;
  departments: string[];
  offices: string[];
  leaveTypes: string[];
};

export type PersonioValues = PersonioBaseConfig & {
  withCustomFields: boolean;
  customFields: Record<string, string | null | undefined> | null | undefined;
};

export type PersonioConfig = PersonioBaseConfig & {
  customFields: Record<string, string> | undefined;
};

export const mapFormDataToPersonioConfig = (formData: PersonioValues): PersonioConfig => ({
  ...formData,
  customFields: formData.withCustomFields ? sanitizeCustomFields(formData.customFields) : undefined
});
